export default __webpack_public_path__ + "static/mobile-logo-e6ce773b08a2bbdc7a6284123bb9ef9b.svg";